import { initShaderProgram } from "../../../../SharedGL/Shader";

export class GroundEventShader {
  // Vertex shader program
  private readonly vsSource = `
    attribute vec4 aVertexPosition;
    attribute vec4 aVertexColor;

    uniform mat4 uModelViewMatrix;
    uniform mat4 uProjectionMatrix;
    uniform highp float uYPos;
    uniform highp vec2 uScale;

    varying lowp vec4 vColor;
    varying highp vec2 vPos;

    void main(void) {
      highp vec4 position = vec4( aVertexPosition.x, aVertexPosition.y + uYPos, aVertexPosition.zw);
      gl_Position = uProjectionMatrix * uModelViewMatrix * position;
      vColor = aVertexColor;
      vPos = vec2(aVertexPosition.x, aVertexPosition.y) * uScale;
    }
  `;

  // Fragment shader program
  // 1 / 80 = 0.0125 multiplying is faster than dividing so we use the magic number
  private readonly fsSource = `
    varying lowp vec4 vColor;
    varying highp vec2 vPos;

    uniform sampler2D uSampler;
    
    void main(void) {
      if(vColor.a < 0.1)
      discard;
      gl_FragColor = mix(texture2D(uSampler, vec2(vPos.x * 0.0125, vPos.y)), vColor, 0.8);
    }
  `;

  public readonly shaderProgram: WebGLProgram;

  constructor(gl: WebGLRenderingContext) {
    this.shaderProgram = initShaderProgram(gl, this.vsSource, this.fsSource);
  }
}
